core.constant('userMeedyTranslationPL', {
  "T": {
    "MEEDY": {
      "SYSTEM": {
        "ERROR": {
          "DUPLICATED_USER_LOGIN": "Wystąpił błąd podczas zapisu! Istnieje już użytkownik o podanym loginie!",
          "DUPLICATED_USER_EMAIL": "Wystąpił błąd podczas zapisu! Istnieje już użytkownik o podanym adresie email!",
          "DUPLICATED_USER_PESEL": "Wystąpił błąd podczas zapisu! Istnieje już użytkownik o podanym numerze PESEL!",
          "DUPLICATED_USER_PRIMARY_PHONE": "Wystąpił błąd podczas zapisu! Istnieje już użytkownik o podanym numerze telefonu!",
          "DUPLICATED_DOCTOR_PWZ": "Wystąpił błąd podczas zapisu! Istnieje już użytkownik o podanym numerze PWZ!",
          "DUPLICATED_CLINIC_NAME": "Wystąpił błąd podczas zapisu! Istnieje już firma o podanej nazwie!",
          "DUPLICATED_CLINIC_REGON": "Wystąpił błąd podczas zapisu! Istnieje już firma o podanym numerze REGON!",
          "DUPLICATED_CLINIC_NIP": "Wystąpił błąd podczas zapisu! Istnieje już firma o podanym numerze NIP!"
        },
        "MESSAGE": {
          "DELETE_ALL_USERS_CONFIRMATION": "Czy na pewno chcesz usunąć użytkowników: ",
          "DELETE_USER_CONFIRMATION": " Czy na pewno chcesz usunąć użytkownika",
          "USER_SEND_NEW_PASSWORD_CONFIRMATION": "Czy na pewno chcesz wygenerować nowe hasło dla użytkownika: "
        }
      },
      "UI": {
        "TABBAR": {
          "USER": {
            "USER": "Użytkownik"
          }
        },
        "BREADCRUMB": {
        },
        "GRID": {
          "USER_PLACEHOLDER" : "Wpisz imię, nazwisko lub email użytkownika"
        },
        "APPLICATION" : {
          "NEW_USER" : "Nowy użytkownik",
          "EDIT_USER" : "Edycja użytkownika",
          "SEND_ACTIVATION_LINK" : "Wyślij link aktywacyjny"
        }
      },
      "DATA": {
        "LOGIN": "Login",
        "USER": "Użytkownik"
      },
      "ENUM": {
        "USER_TYPE": {
          "ADMIN": "Administrator"
        },
        "USER_PARTNER_TYPE" : {
          "RECEPTIONIST" : "Recepcja z dostępem do kalendarzy",
          "MEDICAL_RECEPTIONIST" : "Recepcja z dostępem do dokumentacji medycznej",
          "PHYSICIAN" : "Lekarz"
        },
        "USER_STATUS" : {
          "ACTIVE" : "Aktywny",
          "INACTIVE" : "Nieaktywny",
          "DELETED" : "Skasowany",
          "BLOCKED" : "Zablokowany"
        }
      },
      "MODULE": {
        "TITLE": {
          "MODULE_USERS": "Moduł użytkowników"
        },
        "USER": {
          "TITLE": "Użytkownicy",
          "USER_TYPE": "Typ użytkownika",
          "USER": {
            "USERS": "Użytkownicy",
            "USER": "Użytkownik",
            "CREATE": "Dodaj użytkownika",
            "EDIT": "Edycja użytkownika",
            "VIEW": "Dane użytkownika",
            "ACTIVATE": "Aktywacja użytkownika",
            "DEACTIVATE": "Dezaktywacja użytkownika",
            "BASE_DATA": "Dane podstawowe",
            "ROLES": "Role",
            "AVAILABLE": "Dostępni użytkownicy",
            "ASSIGNED": "Przypisani użytkownicy",
            "SEND_PASSWORD": "Wyślij hasło"
          },
          "USER_DELETE_CONFIRMATION" : "Czy na pewno chcesz usunąć tego użytkownika?",
          "FULL_NAME" : "Imię i nazwisko",
          "EMAIL" : "Email",
          "ACCESS" : "Dostęp",
          "PHONE" : "Telefon",
          "ACTION" : "Akcje",
          "STATUS" : "Status",
          "USER_DATA" : "Dane użytkownika",
          "FIRST_NAME" : "Imię",
          "LAST_NAME" : "Nazwisko",
          "PARTNER_TYPE" : "Rola",
          "REPEAT_PASSWORD" : "Powtórz hasło",
          "PASSWORD" : "Hasło",
          "WELCOME" : "Witaj",
          "WELCOME_TEXT" : "Wpisz hasło aby dokończyć proces rejestracji jako użytkownik {{partnerType}} w {{medicalPost}}.",
          "CONTINUE" : "Dalej",
          "URL_EXPIRED" : "Link wygasł",
          "CHANGE_PASSWORD_PAGE" : "Strona zmiany hasła",
          "OLD_PASSWORD" : "Stare hasło",
          "VERIFICATION_SUCCESS" : "Weryfikacja powiodła się.",
          "PESEL": "Pesel"
        }
      }
    }
  }
});


